import { createContext } from "react";

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export const DEFAULT_BREADCRUMBS: BreadcrumbItem[] = [{ label: "Recipe Boxes", href: "/home" }];

export const areBreadcrumbsEqual = (a: BreadcrumbItem[], b: BreadcrumbItem[]): boolean => {
  if (a.length !== b.length) {
    return false;
  }

  return a.every((item, index) => item.label === b[index]?.label && item.href === b[index]?.href);
};

export type BreadcrumbContextValue = {
  items: BreadcrumbItem[];
  setItems: (items: BreadcrumbItem[]) => void;
};

export const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null);

export const getDefaultBreadcrumbs = () => DEFAULT_BREADCRUMBS;
